import { api } from "@/services/api";
import type {
  PaginatedResponse,
  ZeroResultQuery,
  ZeroResultQueryStatus,
  ZeroResultSearchEvent,
  ZeroResultSearchFilters,
} from "@/types";

export class ZeroResultSearchRepository {
  async findAll(
    filters: ZeroResultSearchFilters = {},
  ): Promise<PaginatedResponse<ZeroResultQuery>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      params.set(key, String(value));
    });

    const response = await api.get(
      `/v1/admin/zero-result-searches?${params.toString()}`,
    );
    return response.data;
  }

  async updateStatus(
    id: string,
    status: ZeroResultQueryStatus,
  ): Promise<ZeroResultQuery> {
    const response = await api.patch(
      `/v1/admin/zero-result-searches/${id}/status`,
      { status },
    );
    return response.data;
  }

  async findEvents(
    queryId: string,
    page = 1,
    limit = 10,
  ): Promise<PaginatedResponse<ZeroResultSearchEvent>> {
    const response = await api.get(
      `/v1/admin/zero-result-searches/${queryId}/events?page=${page}&limit=${limit}`,
    );
    return response.data;
  }
}
